import { render } from "./RelacionUnidades.vue?vue&type=template&id=e2f66638&scoped=true"
import script from "./RelacionUnidades.vue?vue&type=script&lang=js"
export * from "./RelacionUnidades.vue?vue&type=script&lang=js"

import "./RelacionUnidades.vue?vue&type=style&index=0&id=e2f66638&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2f66638"]])

export default __exports__